import { createSlice } from "@reduxjs/toolkit";
import { CreateIpWhteList, DeleteIpWhteList, GetIpWhteList } from "../action/ipWhiteListAction"
import { toastText } from "utils/utils";
const initialState = {
    data: [null],
    isLoading: false,
    error: null,
    count: 0,
    addIsLoading: false,
}
const ipWhiteListSlice = createSlice({
    name: "ipWhiteList",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get All Users
        builder.addCase(GetIpWhteList.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });
        builder.addCase(GetIpWhteList.fulfilled, (state, action) => {
            console.log("action.payload", action.payload)
            state.isLoading = false;
            state.data = action.payload;
            state.count = action.payload.data.total;
        });
        builder.addCase(GetIpWhteList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        // Create IP White List
        builder.addCase(CreateIpWhteList.pending, (state) => {
            state.isLoading = true;
            state.addIsLoading = true;
            state.error = null;
        });
        builder.addCase(CreateIpWhteList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.addIsLoading = false;
            state.data = action.payload;
            console.log("aaa")
            toastText(action.payload.message, "success",);
        });
        builder.addCase(CreateIpWhteList.rejected, (state, action) => {
            toastText(action.payload.message, "error");

            state.isLoading = false;
            state.error = action.payload;
            state.addIsLoading = false;
        });

        // Delete IP White List
        builder.addCase(DeleteIpWhteList.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });
        builder.addCase(DeleteIpWhteList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
            toastText("success", "IP White List Deleted Successfully");
        });
        builder.addCase(DeleteIpWhteList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
})
export default ipWhiteListSlice;